import React from 'react';

export const MissionReady = () => {
  return (
    <section className="mrm2-mission-section">
      <div className="mrm2-mission-content-wrapper">
        <div className="mrm2-mission-text">
          <h2 className="mrm2-mission-title">
            <span className="mrm2-mission-title-span">MISSION-READY</span>{' '}
            <span className="mrm2-mission-title-span">DESIGN</span>{' '}
          </h2>
          <p className="mrm2-mission-description">
            The <span style={{ whiteSpace: 'nowrap' }}>MRM2-10</span> is
            purpose-built with the toughest missions in mind. Every component -
            from its EW-resilient link to its modular airframe - is designed to
            ensure stable, responsive, and predictable handling in the most
            contested environments.
          </p>
        </div>
      </div>
    </section>
  );
};
